import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding, Output, EventEmitter, ElementRef, ViewChild, AfterViewInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { Sidenav } from '../sidenav/sidenav.service';
import { Location } from '@angular/common';
import { Title }  from '@angular/platform-browser';
import { FormControl, Validators } from '@angular/forms';
import { Snackbar } from '../snackbar/snackbar.service';

@Component({
    selector: 'pv-view',
    templateUrl: './view.component.html',
    host: {
        class: 'pv-view-component',
    },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewComponent implements AfterViewInit {

    @Input('toolbarTitle') set toolbarTitle(title: string){
        this.title = title;
        this._titleService.setTitle(title + ' | Culteva');
    }

    @Input() set returnTo(returnUrl: any){
        this.returnUrl = returnUrl;
        this.showMenu = !returnUrl;
    }

    @Input() toolbarColor: string = 'primary';

    @Input() showMenu = true;

    @Input() showToolbar = true;

    @Input() editableTitle = false;

    title: string = '';
    returnUrl: string;
    userObs: any;
    isEditingTitle: boolean = false;

    titleControl: FormControl = new FormControl(null, [Validators.maxLength(64)]);

    @HostBinding('class.print-mode')
    printMode = false;

    @ViewChild('titleInput') titleInput: ElementRef;

    @Output('printModeChange')
    isPrintModeEmitter = new EventEmitter<boolean>();

    @Output('onTitleChange')
    titleUpdateEmitter = new EventEmitter<string>();


    constructor(
        private _sidenav: Sidenav,
        private _route: ActivatedRoute,
        private _router: Router,
        private _location: Location,
        private _titleService: Title,
        private _changeDetector: ChangeDetectorRef,
        private _snackbar: Snackbar,
    ) { }

    ngAfterViewInit() {
        this.titleControl.patchValue(this.title);
    }

    ngOnDestroy() {

    }

    home(){
        this._sidenav.open();
    }

    back(){
        this._location.back();
    }

    togglePrintMode(printNow = false){
        this.printMode = !this.printMode;
        this.isPrintModeEmitter.emit(this.printMode);
        this._changeDetector.markForCheck();

        if(printNow){
            setTimeout(() => {
                this.print();
            },  600);
        }

    }

    print(){
        window.print();
    }

    printModeChange(){
        return this.isPrintModeEmitter.asObservable();
    }

    editTitle() {
        if (!this.editableTitle) return;
        this.titleControl.patchValue(this.title);
        this.isEditingTitle = true;

        setTimeout(() => {
            if (this.titleInput) {
                this.titleInput.nativeElement.focus();
            }
        }, 0);

        this._changeDetector.markForCheck();
    }

    submitTitle() {
        if (!this.editableTitle) return;

        if (!this.titleControl.valid) {
            this.titleControl.patchValue(this.title);
            return this._snackbar.error("Title must be shorter than 64 characters");
        }

        this.isEditingTitle = false;
        const newTitle = this.titleControl.value.trim();

        if (this.title == newTitle) return;

        this.title = newTitle;

        this.titleUpdateEmitter.emit(newTitle);

        this._changeDetector.markForCheck();
    }

}